<template>
  <div class="city-contain">
    <div class="city-box line_bottom" v-for="(item,index) in rankList" :key="index">
      <!-- <div class="city-name" v-if="item.areaType==1&&checked" :class="(index==rankList.length-1 || index==rankList.length-2)?' onCur':''">{{item.ranking}}</div>
      <div class="city-name" v-if="item.areaType==2&&checked" :class="index==rankList.length-1?' onCur':''" >{{item.ranking}}</div> -->
      <!-- <div class="city-name"  v-if="(item.areaType==1||item.areaType==2) &&!checked " >{{item.ranking}}</div> -->
      <!-- <div class="city-name" >{{ index+1 }}</div> -->
      <div class="city-name" >{{ item.ranking }}</div>
      <div class="right-box" @click="navTo(item)">
        <div class="city">{{item.areaName}}</div>
        <div class="progress">
          <!-- <div class="line-box">进度条隐藏
            一类最后2条高亮
            <div class="line" v-if="item.areaType==1&&checked" :class="(index==rankList.length-1 || index==rankList.length-2)?'onCur':''" :style="'width:' + item.score + '%'"></div>
            二类最后一条高亮
            <div class="line" v-if="item.areaType==2&&checked" :class="index==rankList.length-1?'onCur':''" :style="'width:' + item.score + '%'"></div>
            全部不高亮
            <div class="line" v-if="(item.areaType==1||item.areaType==2) &&!checked "  :style="'width:' + item.score + '%'"></div>
          </div>-->
          <div class="mark">{{item.score}}分</div>
          <div class="rank-box" v-if="item.oldRanking===0">-</div>
          <div class="rank-box" v-else>
            <div class="blue" v-if="Number(item.diffRanking) == 0">持平</div>
            <div class="num mbt0" :class="Number(item.diffRanking) >= 1?'up-up':'num-down'" v-else>
              <span v-if="Number(item.diffRanking) > 0">+</span>
              {{item.diffRanking}}
            </div>
            <div class="up-up txt" v-if="Number(item.diffRanking) > 0">&#160;↑</div>
            <div class="down-down txt" v-if="Number(item.diffRanking) < 0">&#160;↓</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'rankCharts',
        props: {
            'rankList': Array,
            'checked': Boolean
        },
        data () {
            return {
                isUp: false,
                maxWidth: '30px'
            }
        },
        mounted () {
            // 计算进度条长度
            // let nameArry = []
            // for (let index = 0; index < this.rankList.length; index++) {
            //     nameArry.push(this.rankList[index].city)
            // }
            // var longest = nameArry.sort(function (a, b) { return b.length - a.length; })[0];
            // console.log('longest:', longest.length)
            // this.maxWidth = longest.length * 18.5 + 'px'
        },
        methods: {
            navTo (area) {
                // console.log(area, 'area')
                this.$emit('navToDetail', area)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .city-box{
    // border-bottom: 1px solid #eeeeee;
    padding: 12px 16px;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    .city-name{
      display: flex;
      font-size:14px;
      font-family:DIN-Bold,DIN;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:14px;
      justify-content: flex-end;
      white-space: nowrap;
    }
      .onCur{
          color: #FF8C19 !important;
        }
    .right-box{
      margin-left: 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .city{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:10px;
      }
      .progress{
        display: flex;
        align-items: center;
      .line-box{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        .line{
          height: 6px;
          background: #36B374;
        }
        .onCur{
          background: #FF8C19 !important;
        }
      }
      .mark{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:10px;
        margin-left: 12px;
        white-space: nowrap;
      }
      .rank-box{
        margin-left: 15px;
        display: flex;
        // align-items: center;
        width: 30px;
        text-align: right;
        justify-content: flex-end;
        .up-up{
          font-size:10px;
          font-weight:400;
          color:rgba(54,179,116,1);
          line-height:10px;
          // margin-bottom: 2.5px;
        }
        .down-down{
          font-size:10px;
          font-weight:400;
          color:rgba(255,77,77,1);
          line-height:10px;
          // margin-bottom: 2.5px;
        }
        .txt{
            display: flex;
          align-items: center;
          .r-img{
            width: 8px;
            height: 12px;
          }
        }
        .num{
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          line-height:10px;
          margin-left: 4px;
        }
        .blue{
          color: #2283E6;
          font-size: 10px;
        }
        .num-up{
          color:rgba(54,179,116,1);
        }
        .num-down{
          color:rgba(255,77,77,1);
        }
      }
      }
    }
  }
  .line_bottom:last-child::after{
    background: none;
  }
  // .line_bottom:first-child::after{
  //   background: none;
  // }
  // .line_bottom:not(:last-child)::after{
  //   background: none;
  // }
  .mbt0{
   margin-bottom: 0;
    padding-top: 1px;
  }
}
</style>
